// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.0-next',
  revision: '02ad25a48',
  branch: 'next',
  date: 'Tue, 04 Aug 2026 15:09:16 GMT'
};